import { useQuery } from '@tanstack/react-query';
import { endpoints } from '@rossum/api-client';
import { api } from '../../../lib/apiClient';

const USER_KEY = 'user';

export const useUser = () => {
  return useQuery({
    queryKey: [USER_KEY],
    queryFn: () => api.request(endpoints.authentication.user()),
  });
};
